export const SOMETHING_WENT_WRONG = 'Lo sentimos, algo salió mal'
export const SESSION_CLOSED = 'Por su seguridad, su sesión fue finalizada'
